import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_2 = {
  key: 1,
  class: "error"
}
const _hoisted_3 = {
  key: 2,
  class: "error"
}

import TopList, { BarConfiguration } from '@/components/AnalyticsDashboard/components/TopList.vue'
import CardInteractive from './CardInteractive.vue'
import { ToplistResponse } from '@/api-client/models/indoorclimate/Contracts'
import { FormatOptions } from '../formatter'
import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import { useDataSource } from '@/composables/useDataSources'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TextBase from '@/design-system/atoms/TextBase.vue'
import { EntityLevel, useEntityLevel } from '@/composables/useEntityLevel'
import { storeToRefs } from 'pinia'

type ErrorState = 'NO_DATA' | 'INVALID_FILTER'

type Props = {
  barOptions: BarConfiguration[]
  format: FormatOptions
  dataSource: string
  enabledEntityLevels?: EntityLevel[]
  errorMessages?: Record<ErrorState, string>
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardTopList',
  props: {
    barOptions: {},
    format: {},
    dataSource: {},
    enabledEntityLevels: {},
    errorMessages: {}
  },
  setup(__props: any) {

const props = __props
const dataSourceId = ref(props.dataSource)
const dataSource = useDataSource<ToplistResponse>(dataSourceId)
const { entityLevel } = storeToRefs(useEntityLevel())
const data = computed(() => dataSource.value)

const correctFilter = computed(() => {
  if (props.enabledEntityLevels) {
    return props.enabledEntityLevels.includes(entityLevel.value)
  }
  return true
})

const { locale } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardInteractive, {
    title: '',
    info: '',
    enableFullscreen: true,
    isLoading: data.value?.isLoading
  }, {
    default: _withCtx(() => [
      (data.value?.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(PulseLoader, {
              loading: true,
              color: "#3F46D6"
            })
          ]))
        : (data.value?.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(TextBase, {
                text: data.value?.error,
                type: "label"
              }, null, 8, ["text"])
            ]))
          : (!correctFilter.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (correctFilter.value)
                  ? (_openBlock(), _createBlock(TextBase, {
                      key: 0,
                      text: _ctx.errorMessages?.NO_DATA[_unref(locale)],
                      type: "label"
                    }, null, 8, ["text"]))
                  : (_openBlock(), _createBlock(TextBase, {
                      key: 1,
                      text: _ctx.errorMessages?.INVALID_FILTER[_unref(locale)],
                      type: "label"
                    }, null, 8, ["text"]))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (data.value?.data)
                  ? (_openBlock(), _createBlock(TopList, {
                      key: 0,
                      toplist: data.value?.data,
                      format: _ctx.format,
                      barOptions: _ctx.barOptions,
                      locale: _unref(locale)
                    }, null, 8, ["toplist", "format", "barOptions", "locale"]))
                  : _createCommentVNode("", true)
              ], 64))
    ]),
    _: 1
  }, 8, ["isLoading"]))
}
}

})